import { useState } from 'react';

import { getUserBySearch } from 'src/apis/authApi';
import { SearchDateRangeForm } from 'src/components/common/form/search/SearchDateRangeForm';
import { SearchCodeModalForm } from 'src/components/common/form/search/SearchCodeModalForm';
import { SearchSectionForm } from 'src/components/common/form/search/SearchSectionForm';
import { useInfoFormEvents } from 'src/hooks/useInfoFormEvents';
import useUiuxStore from 'src/store/useUiuxStore';
import { InfoCodeSearchFieldConfig } from 'src/types/info-form';

import { defaultSYS5010_R01Filter, useSYS5010_R01Store } from './Store_SYS5010_R01';

interface Props {
	onEnterKeyDown: () => void;
}

export const SearchSection_SYS5010_R01 = ({ onEnterKeyDown }: Props) => {
	const { SYS5010_R01Filter, setSYS5010_R01Filter } = useSYS5010_R01Store();
	const { setCodeSearchModalProps } = useUiuxStore();

	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({
		top: 0,
		left: 0,
	});
	const userFocusId = 'user_search_SYS5010';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'userId',
			category: '사용자',
			focusId: userFocusId,
			responseMapping: {
				userId: 'userId',
				userNm: 'userNm',
			},
			searchFunction: async (code: string) => {
				const userResponse = await getUserBySearch('');
				return userResponse.data.data.find((value: any) => value.userId === code);
			},
			extraFilter: () => ({
				userId: SYS5010_R01Filter.userId || '',
				userNm: SYS5010_R01Filter.userNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: SYS5010_R01Filter,
		setEditData: setSYS5010_R01Filter,
		defaultData: defaultSYS5010_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'SYS5010_R01_search',
	});

	return (
		<SearchSectionForm>
			<SearchDateRangeForm
				label="기간"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={SYS5010_R01Filter.dateRange}
				setDateRange={(dateRange) => setSYS5010_R01Filter({ dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>

			<SearchCodeModalForm
				label="Login ID"
				value={SYS5010_R01Filter.userId}
				valueLabel={SYS5010_R01Filter.userNm}
				handleFoucsId={userFocusId}
				onChange={getFieldHandlers('userId').onChange}
				onDoubleClick={getFieldHandlers('userId').onDoubleClick}
				onKeyDown={getFieldHandlers('userId').onEnterKeyDown}
			/>
		</SearchSectionForm>
	);
};

export default SearchSection_SYS5010_R01;
